<style lang="stylus">
    .wb-historyView
        position relative
        height 100%
        page_background()
        flex 1
        padding $indexContainerPadding
        user-select none

        .emptyCloud
            position absolute
            top 180px
            left 50%
            transform translate(-50%,0)
            span
                color #222
        .historyView-list-header
            >div
                cursor default
                &:hover
                    background-color unset
        .grid-box-list
            display flex
            flex-wrap wrap
            margin-top -20px
            padding-left 1px
    .pc-historyView
        padding 12px 0 0 40px
        page_background()
        .files-hv-splice
            width calc(100vw - 240px)
    .ivu-dropdown
        .ivu-dropdown-rel
            a:focus,a:hover
                color var(--themeColor)!important
    .files-order-box
        &:hover,&:focus
            border-color var(--themeColor)!important
            box-shadow unset!important
    .files-hv-splice
        display flex
        align-items center
        justify-content flex-start
        overflow hidden
        width calc(100vw - 286px)
        padding 20px 0
        padding-left 24px
        span
            padding-right 10px
            font-size 14px
            color #505A6F
            flex-shrink 0
            page_background()
        .hv-line
            height 1px
            width 100%
            margin-top -10px
            background #F3F2F2
    .grid-box-list
        .files-hv-splice
            padding-left 0
    .wb-historyView.isTeamsApp
        @media screen and (max-width: 500px)
            padding 30px 0 0 15px
            .files-hv-splice
                width calc(100vw - 10px)
</style>

<template>
    <div
        class="wb-historyView"
        ref="rootDom"
        :class="{ 'pc-historyView': isPC, 'dark-theme__workbench': isPCDarkMode == 2, isTeamsApp: isTeamsApp }"
        @click="clear()"
    >
        <RightMenu
            v-if="contextmenuBoxShow"
            :style="{ top: top + 'px', left: left + 'px' }"
            :menuList="menuList"
            @handleClicks="handleClick($event)"
        />

        <WbHeader v-if="isPC" :outside="true" :from="'history'" @wbHeaderEvent="wbHeaderEvent" />

        <div class="filter-box" :class="{ 'filter-box-pc': isPC }">
            <div class="search-box">
                <input
                    autocomplete="off"
                    spellcheck="false"
                    type="text"
                    :data-locate="'search-input'"
                    v-model="searchValue"
                    :placeholder="$t('search')"
                    @keypress="enter($event)"
                />
                <button class="search-icon" :data-locate="'search-btn'" @click="search()">
                    <iconSymbol :name="'fileSearchIcon'" />
                </button>
            </div>
            <button class="button-box" @click="setLayout()" :title="$t('switchView')">
                <iconSymbol :name="layoutMode == 'list' ? 'gridViewIcon' : 'listViewIcon'"></iconSymbol>
            </button>
        </div>

        <FileNum v-if="isPC" class="filenum-tips-pc" />

        <div style="overflow: hidden">
            <FilesSelector
                v-if="mulSelectMode"
                :type="'openRecord'"
                :totalNum="activeList.length"
                :fileNum="selectFilesIndex.length"
                :s_margin="s_margin"
                @selectAllFiles="selectAllFiles"
                @cancelSelect="cancelSelect"
                @delFiles="deleteRecord"
            />
        </div>
        <div v-if="layoutMode == 'list' && !searchMode" class="list-header historyView-list-header">
            <div class="file-name">
                <span>{{ $t("name") }}</span>
            </div>
            <div class="file-time">
                <span>{{ $t("time") }}</span>
            </div>
            <div class="file-size">
                <span>{{ $t("size") }}</span>
            </div>
        </div>
        <div class="files-scroll" :style="{ height: scrollboxHeight }" @scroll="clear" ref="filesScroll">
            <DragSelector
                :boxClassName="layoutMode == 'grid' ? 'files-item' : 'files-item-list'"
                :scrollDom="$refs.filesScroll"
                :containerDom="$refs.filesBoxList"
                @dragMouseDown="dragMouseDown"
                @dragMouseMove="dragMouseMove"
                @dragMouseUp="dragMouseUp"
                @setActiveList="
                    (data) => {
                        this.selectFilesIndex = data;
                    }
                "
            />
            <div class="emptyCloud" v-cloak v-if="userInfo && !pcNoLogin && filesList && filesList.length == 0 && !loadingStatus">
                <img src="@/home/assets/img/null-icon/default-null.svg" alt="" />
                <span>{{ $t("notTem") }}</span>
            </div>
            <pclogin />

            <template v-if="layoutMode == 'grid'">
                <div class="files-box" v-if="searchMode" ref="filesBoxList">
                    <gridFile
                        v-for="(item, index) in searchMode ? searchList : filesList"
                        :key="index"
                        :type="'openRecord'"
                        :mode="'search'"
                        :index="index"
                        :mulSelectMode="mulSelectMode"
                        :file="item"
                        @enterMulSelectMode="mulSelectMode = true"
                        @cancelMulSelectMode="mulSelectMode = false"
                        @closeContextmenu="contextmenuBoxShow = false"
                    />
                </div>

                <div class="files-box-list grid-box-list" v-else ref="filesBoxList">
                    <div class="files-hv-splice" v-if="nowList.length > 0">
                        <span>{{ $t("date-now") }}</span>
                        <img class="hv-dashed" :src="require(`@/home/assets/img/history-line${isPCDarkMode == 2 ? '-dark' : ''}.svg`)" alt="" />
                    </div>
                    <gridFile
                        v-for="item in nowList"
                        :key="item.index"
                        :type="'openRecord'"
                        :mode="'files'"
                        :index="item.index"
                        :mulSelectMode="mulSelectMode"
                        :file="item"
                        @enterMulSelectMode="mulSelectMode = true"
                        @cancelMulSelectMode="mulSelectMode = false"
                        @closeContextmenu="contextmenuBoxShow = false"
                        @setStarFile="setStarFile"
                    />
                    <div class="files-hv-splice" v-if="preList.length > 0">
                        <span>{{ $t("date-preday") }}</span>
                        <img class="hv-dashed" :src="require(`@/home/assets/img/history-line${isPCDarkMode == 2 ? '-dark' : ''}.svg`)" alt="" />
                    </div>
                    <gridFile
                        v-for="item in preList"
                        :key="item.index"
                        :type="'openRecord'"
                        :mode="'files'"
                        :index="item.index"
                        :mulSelectMode="mulSelectMode"
                        :file="item"
                        @enterMulSelectMode="mulSelectMode = true"
                        @cancelMulSelectMode="mulSelectMode = false"
                        @closeContextmenu="contextmenuBoxShow = false"
                        @setStarFile="setStarFile"
                    />
                    <div class="files-hv-splice" v-if="sevenList.length > 0">
                        <span>{{ $t("date-7day") }}</span>
                        <img class="hv-dashed" :src="require(`@/home/assets/img/history-line${isPCDarkMode == 2 ? '-dark' : ''}.svg`)" alt="" />
                    </div>
                    <gridFile
                        v-for="item in sevenList"
                        :key="item.index"
                        :type="'openRecord'"
                        :mode="'files'"
                        :index="item.index"
                        :mulSelectMode="mulSelectMode"
                        :file="item"
                        @enterMulSelectMode="mulSelectMode = true"
                        @cancelMulSelectMode="mulSelectMode = false"
                        @closeContextmenu="contextmenuBoxShow = false"
                        @setStarFile="setStarFile"
                    />
                    <div class="files-hv-splice" v-if="nowMList.length > 0">
                        <span>{{ $t("date-nowMonth") }}</span>
                        <img class="hv-dashed" :src="require(`@/home/assets/img/history-line${isPCDarkMode == 2 ? '-dark' : ''}.svg`)" alt="" />
                    </div>
                    <gridFile
                        v-for="item in nowMList"
                        :key="item.index"
                        :type="'openRecord'"
                        :mode="'files'"
                        :index="item.index"
                        :mulSelectMode="mulSelectMode"
                        :file="item"
                        @enterMulSelectMode="mulSelectMode = true"
                        @cancelMulSelectMode="mulSelectMode = false"
                        @closeContextmenu="contextmenuBoxShow = false"
                        @setStarFile="setStarFile"
                    />
                    <div class="files-hv-splice" v-if="preMList.length > 0">
                        <span>{{ $t("date-preMonth") }}</span>
                        <img class="hv-dashed" :src="require(`@/home/assets/img/history-line${isPCDarkMode == 2 ? '-dark' : ''}.svg`)" alt="" />
                    </div>
                    <gridFile
                        v-for="item in preMList"
                        :key="item.index"
                        :type="'openRecord'"
                        :mode="'files'"
                        :index="item.index"
                        :mulSelectMode="mulSelectMode"
                        :file="item"
                        @enterMulSelectMode="mulSelectMode = true"
                        @cancelMulSelectMode="mulSelectMode = false"
                        @closeContextmenu="contextmenuBoxShow = false"
                        @setStarFile="setStarFile"
                    />
                    <div class="files-hv-splice" v-if="prePreMList.length > 0">
                        <span>{{ new Date().getMonth() + 1 + $t("date-month") }}</span>
                        <img class="hv-dashed" :src="require(`@/home/assets/img/history-line${isPCDarkMode == 2 ? '-dark' : ''}.svg`)" alt="" />
                    </div>
                    <gridFile
                        v-for="item in prePreMList"
                        :key="item.index"
                        :type="'openRecord'"
                        :mode="'files'"
                        :index="item.index"
                        :mulSelectMode="mulSelectMode"
                        :file="item"
                        @enterMulSelectMode="mulSelectMode = true"
                        @cancelMulSelectMode="mulSelectMode = false"
                        @closeContextmenu="contextmenuBoxShow = false"
                        @setStarFile="setStarFile"
                    />
                    <div class="files-hv-splice" v-if="otherList.length > 0">
                        <span>{{ $t("date-other") }}</span>
                        <img class="hv-dashed" :src="require(`@/home/assets/img/history-line${isPCDarkMode == 2 ? '-dark' : ''}.svg`)" alt="" />
                    </div>
                    <gridFile
                        v-for="item in otherList"
                        :key="item.index"
                        :type="'openRecord'"
                        :mode="'files'"
                        :index="item.index"
                        :mulSelectMode="mulSelectMode"
                        :file="item"
                        @enterMulSelectMode="mulSelectMode = true"
                        @cancelMulSelectMode="mulSelectMode = false"
                        @closeContextmenu="contextmenuBoxShow = false"
                        @setStarFile="setStarFile"
                    />
                </div>
            </template>

            <template v-if="layoutMode == 'list'">
                <div class="list-cons" v-if="searchMode">
                    <div class="files-box-list" ref="filesBoxList">
                        <listFile
                            v-for="(item, index) in searchList"
                            :key="`search-${searchValue}-${index}`"
                            :type="'openRecord'"
                            :mode="'search'"
                            :index="index"
                            :mulSelectMode="mulSelectMode"
                            :file="item"
                            @enterMulSelectMode="mulSelectMode = true"
                            @cancelMulSelectMode="mulSelectMode = false"
                            @closeContextmenu="contextmenuBoxShow = false"
                            @setStarFile="setStarFile"
                        />
                    </div>
                </div>

                <div class="list-cons" v-else>
                    <div class="files-box-list" ref="filesBoxList">
                        <div class="files-hv-splice" v-if="nowList.length > 0">
                            <span>{{ $t("date-now") }}</span>
                            <img class="hv-dashed" :src="require(`@/home/assets/img/history-line${isPCDarkMode == 2 ? '-dark' : ''}.svg`)" alt="" />
                        </div>
                        <listFile
                            v-for="item in nowList"
                            :key="item.index"
                            :type="'openRecord'"
                            :mode="'files'"
                            :index="item.index"
                            :mulSelectMode="mulSelectMode"
                            :file="item"
                            @enterMulSelectMode="mulSelectMode = true"
                            @cancelMulSelectMode="mulSelectMode = false"
                            @closeContextmenu="contextmenuBoxShow = false"
                            @setStarFile="setStarFile"
                        />
                        <div class="files-hv-splice" v-if="preList.length > 0">
                            <span>{{ $t("date-preday") }}</span>
                            <img class="hv-dashed" :src="require(`@/home/assets/img/history-line${isPCDarkMode == 2 ? '-dark' : ''}.svg`)" alt="" />
                        </div>
                        <listFile
                            v-for="item in preList"
                            :key="item.index"
                            :type="'openRecord'"
                            :mode="'files'"
                            :index="item.index"
                            :mulSelectMode="mulSelectMode"
                            :file="item"
                            @enterMulSelectMode="mulSelectMode = true"
                            @cancelMulSelectMode="mulSelectMode = false"
                            @closeContextmenu="contextmenuBoxShow = false"
                            @setStarFile="setStarFile"
                        />
                        <div class="files-hv-splice" v-if="sevenList.length > 0">
                            <span>{{ $t("date-7day") }}</span>
                            <img class="hv-dashed" :src="require(`@/home/assets/img/history-line${isPCDarkMode == 2 ? '-dark' : ''}.svg`)" alt="" />
                        </div>
                        <listFile
                            v-for="item in sevenList"
                            :key="item.index"
                            :type="'openRecord'"
                            :mode="'files'"
                            :index="item.index"
                            :mulSelectMode="mulSelectMode"
                            :file="item"
                            @enterMulSelectMode="mulSelectMode = true"
                            @cancelMulSelectMode="mulSelectMode = false"
                            @closeContextmenu="contextmenuBoxShow = false"
                            @setStarFile="setStarFile"
                        />
                        <div class="files-hv-splice" v-if="nowMList.length > 0">
                            <span>{{ $t("date-nowMonth") }}</span>
                            <img class="hv-dashed" :src="require(`@/home/assets/img/history-line${isPCDarkMode == 2 ? '-dark' : ''}.svg`)" alt="" />
                        </div>
                        <listFile
                            v-for="item in nowMList"
                            :key="item.index"
                            :type="'openRecord'"
                            :mode="'files'"
                            :index="item.index"
                            :mulSelectMode="mulSelectMode"
                            :file="item"
                            @enterMulSelectMode="mulSelectMode = true"
                            @cancelMulSelectMode="mulSelectMode = false"
                            @closeContextmenu="contextmenuBoxShow = false"
                            @setStarFile="setStarFile"
                        />
                        <div class="files-hv-splice" v-if="preMList.length > 0">
                            <span>{{ $t("date-preMonth") }}</span>
                            <img class="hv-dashed" :src="require(`@/home/assets/img/history-line${isPCDarkMode == 2 ? '-dark' : ''}.svg`)" alt="" />
                        </div>
                        <listFile
                            v-for="item in preMList"
                            :key="item.index"
                            :type="'openRecord'"
                            :mode="'files'"
                            :index="item.index"
                            :mulSelectMode="mulSelectMode"
                            :file="item"
                            @enterMulSelectMode="mulSelectMode = true"
                            @cancelMulSelectMode="mulSelectMode = false"
                            @closeContextmenu="contextmenuBoxShow = false"
                            @setStarFile="setStarFile"
                        />
                        <div class="files-hv-splice" v-if="prePreMList.length > 0">
                            <span>{{ new Date().getMonth() + 1 + $t("date-month") }}</span>
                            <img class="hv-dashed" :src="require(`@/home/assets/img/history-line${isPCDarkMode == 2 ? '-dark' : ''}.svg`)" alt="" />
                        </div>
                        <listFile
                            v-for="item in prePreMList"
                            :key="item.index"
                            :type="'openRecord'"
                            :mode="'files'"
                            :index="item.index"
                            :mulSelectMode="mulSelectMode"
                            :file="item"
                            @enterMulSelectMode="mulSelectMode = true"
                            @cancelMulSelectMode="mulSelectMode = false"
                            @closeContextmenu="contextmenuBoxShow = false"
                            @setStarFile="setStarFile"
                        />
                        <div class="files-hv-splice" v-if="otherList.length > 0">
                            <span>{{ $t("date-other") }}</span>
                            <img class="hv-dashed" :src="require(`@/home/assets/img/history-line${isPCDarkMode == 2 ? '-dark' : ''}.svg`)" alt="" />
                        </div>
                        <listFile
                            v-for="item in otherList"
                            :key="item.index"
                            :type="'openRecord'"
                            :mode="'files'"
                            :index="item.index"
                            :mulSelectMode="mulSelectMode"
                            :file="item"
                            @enterMulSelectMode="mulSelectMode = true"
                            @cancelMulSelectMode="mulSelectMode = false"
                            @closeContextmenu="contextmenuBoxShow = false"
                            @setStarFile="setStarFile"
                        />
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script lang="ts">
    import naturalsort from "javascript-natural-sort";

    naturalsort.insensitive = true;
    import { Component, Prop, Vue, Mixins, Watch } from "vue-property-decorator";
    import fileItem from "./fileItem";
    import listFile from "./listFile.vue";
    import gridFile from "./gridFile.vue";
    import FilesSelector from "./FilesSelector.vue";
    import DragSelector from "./DragSelector.vue";
    import pclogin from "@/home/parts/pclogin.vue";
    import RightMenu from "./RightMenu.vue";
    import WbHeader from "./Wb-header.vue";
    import FileNum from "./vip/fileNum.vue";

    @Component({
        components: {
            fileItem,
            listFile,
            gridFile,
            FilesSelector,
            DragSelector,
            pclogin,
            RightMenu,
            WbHeader,
            FileNum,
        },
    })
    export default class WbHistoryView extends Mixins(fileItem) {
        filesList = [];
        searchList = [];
        searchValue = "";
        deleteRecordBlock = false;
        loadingStatus = true;

        nowList = [];
        preList = [];
        sevenList = [];
        nowMList = [];
        preMList = [];
        prePreMList = [];
        otherList = [];

        get searchMode() {
            return this.$store.state.history.searchMode;
        }
        set searchMode(v) {
            this.$store.commit("setHistoryStatus", {
                searchMode: v,
            });
        }
        wbHeaderEvent(obj) {
            let instance = this;
            let func = instance && obj.func_name ? instance[obj.func_name] : null;
            func && func(obj.args);
        }

        handleClick(index) {
            let clickEvents = new Map([
                [
                    0,
                    () => {
                        this.fileSelected.length == 1 &&
                            this.openFiles(this.searchValue ? this.searchList[this.fileSelected[0]] : this.filesList[this.fileSelected[0]]);
                    },
                ],
                [
                    1,
                    () => {
                        this.fileSelected.length == 1 && this.locateFile();
                    },
                ],
                [
                    2,
                    () => {
                        this.deleteRecord();
                    },
                ],
            ]);
            const onClicks = clickEvents.get(index);
            onClicks && onClicks();
        }
        dragMouseDown() {
            this.clearFile(1);
        }
        dragMouseMove() {}
        dragMouseUp(isMove, isClickFile) {
            if (!isMove) {
                if (this.mulSelectMode && isClickFile) {
                } else {
                    this.clearFile();
                }
            } else this.selectFilesIndex.length > 0 && (this.mulSelectMode = true);
        }

        get pcNoLogin() {
            return this.isPC && !this.params.islogin;
        }
        toPCLogin() {
            (<any>window).$qt.jsCallUserLogin();
        }
        get userInfo() {
            return this.$store.state.userInfo;
        }
        @Watch("userInfo.islogin")
        onLoginChanged(val, oldval) {
            if (this.isPC) {
                if (val && !oldval) {
                    this.getHistoryViewList();
                    this.$bus.$emit("pcLoginEvenvt");
                } else if (!val && oldval) {
                    this.filesList = [];
                    this.searchList = [];
                    this.nowList = [];
                    this.preList = [];
                    this.sevenList = [];
                    this.nowMList = [];
                    this.preMList = [];
                    this.prePreMList = [];
                    this.otherList = [];
                }
            }
        }

        // 多语言要写在 computed 中
        get menuList() {
            let list = [
                { key: 0, label: this.$t("openFile"), ban: this.fileSelected.length > 1 },
                { key: 1, label: this.$t("locateFile"), hide: !this.isPC, ban: this.fileSelected.length > 1 },
                { key: 2, label: this.$t("deleteRecord") },
            ];
            return list.filter((i) => (i.hasOwnProperty("hide") ? i.hide : true));
        }

        get layoutMode() {
            return this.$store.state.layoutMode;
        }
        set layoutMode(v) {
            this.$store.commit("setState", {
                type: "layoutMode",
                data: v,
            });
        }
        get top() {
            return this.$store.state.layoutTop;
        }
        set top(v) {
            this.$store.commit("setState", {
                type: "layoutTop",
                data: v,
            });
        }
        get left() {
            return this.$store.state.layoutLeft;
        }
        set left(v) {
            this.$store.commit("setState", {
                type: "layoutLeft",
                data: v,
            });
        }
        get contextmenuBoxShow() {
            return this.$store.state.fileContextShow;
        }

        set contextmenuBoxShow(v) {
            this.$store.commit("setState", {
                type: "fileContextShow",
                data: v,
            });
        }
        get selectFilesIndex() {
            return this.$store.state.selectFilesIndex;
        }
        set selectFilesIndex(v) {
            this.$store.commit("setState", {
                type: "selectFilesIndex",
                data: v,
            });
        }
        get activeList() {
            return this.searchMode ? this.searchList : this.filesList;
        }
        get showFileNumTips() {
            return this.$store.getters.showFileNumTips(this);
        }

        // mulSelect
        mulSelectMode = false;
        get scrollboxHeight() {
            let selectorH = 46; // 多选工具栏高度
            let listHeadH = 64; // 列表头高度 含margin-b
            let pathTitle = this.isPC ? 43 : 0; // 文件路径标题
            let selectorMarginT = 0; // 多选工具栏margin-top
            let selectorMarginB = 16; // 多选工具栏margin-bottom
            let fileNumLimit = this.isPC && this.showFileNumTips ? 48 : 0;
            let baseHeight = this.mulSelectMode ? selectorH + selectorMarginT + selectorMarginB : 0; // 多选工具栏整体高度
            let allHeight = baseHeight + pathTitle + fileNumLimit;
            if (this.layoutMode == "list") {
                return this.searchMode ? `calc(100% - ${allHeight}px)` : `calc(100% - ${allHeight + listHeadH}px)`;
            } else {
                return this.searchMode ? `calc(100% - ${allHeight}px)` : `calc(100% - ${allHeight}px)`;
            }
        }
        get s_margin() {
            return "0 40px 16px 0";
        }
        selectAllFiles(type) {
            if (!type) {
                this.clearFile(1);
            } else {
                let arr = [];
                for (let i = 0; i < this.activeList.length; i++) {
                    arr.push(i);
                }
                this.$store.commit("setState", {
                    type: "selectFilesIndex",
                    data: arr,
                });
            }
        }
        cancelSelect() {
            this.clearFile();
        }

        activated() {
            this.clearFile();
        }
        receiveMessage(event) {
            if (event.origin !== location.origin) return;
            if (event.data.type && event.data.type == "updateMyfile") {
                // 更新最近浏览文件
                if (event.data.updateRecentFile) {
                    this.getHistoryViewList();
                }
            }
        }
        mounted() {
            (<any>window).$qt && (<any>window).$qt.jsCallWebUIDisplay && (<any>window).$qt.jsCallWebUIDisplay(); // 通知客户端ui渲染完成

            window.addEventListener("message", this.receiveMessage, false);
        }

        searchBack() {
            this.searchMode = false;
            this.searchValue = "";
        }
        clearFile(keepMulSelectMode = 0) {
            this.selectFilesIndex = [];
            !keepMulSelectMode && (this.mulSelectMode = false);
        }

        enter(e) {
            if (e.keyCode == 13) {
                this.search();
            }
        }

        search() {
            if (this.searchValue) {
                this.searchMode = true;
                this.searchList = [];
                this.$store.commit("setState", { data: true, type: "showLoading" });
                this.searchValue = this.searchValue.trim();
                this.searchList = this.filesList.filter((item) => {
                    if (item.name.toLowerCase().includes(this.searchValue.toLowerCase())) {
                        if (this.isPrivate) {
                            item.filePath = item.prefix ? this.$t("personal") + ">" + item.prefix : this.$t("personal");
                        } else {
                            let filePath = item.key.match(/[^\/]+\/[^\/]+\/(.+)/) && item.key.match(/[^\/]+\/[^\/]+\/(.+)/)[1];
                            filePath = filePath.split("/");
                            let name = filePath.pop();
                            filePath = filePath.length ? this.$t("personal") + ">" + filePath.join(">") : this.$t("personal");
                            item.filePath = filePath;
                        }
                        return true;
                    }
                    return false;
                });
                if (this.searchList.length == 0) {
                    (<any>this).$edMessage.error(this.$t("notFind"));
                }
                this.$store.commit("setState", { data: false, type: "showLoading" });
            } else {
                this.searchMode = false;
            }
        }
        visibilitychangeEvent() {
            let state = document.visibilityState;
            if (state == "visible") {
                this.getHistoryViewList();
            }
        }
        created() {
            this.isPC && this.$store.commit("setState", { data: 11, type: "selectId" });
            this.$bus.$on("refreshHistoryView", () => {
                this.getHistoryViewList();
            });
            if (this.userInfo) {
                if (!this.params.islogin) {
                    return;
                }
                this.getHistoryViewList();
            } else {
                this.$bus.$on("loginSucc-history", () => {
                    this.getHistoryViewList();
                });
            }
            document.addEventListener("visibilitychange", this.visibilitychangeEvent);
        }

        clear() {
            this.contextmenuBoxShow = false;
        }

        setLayout() {
            this.$store.commit("changeLayout");
            this.clearFile();
        }

        getHistoryViewList() {
            if (!this.params || !this.params.islogin) {
                return;
            }
            this.loadingStatus = true;
            this.filesList = [];
            this.$store.commit("setState", { data: true, type: "showLoading" });
            let obj = {
                platform: this.$store.state.publicStore.runPlatform,
            };
            Object.assign(obj, this.params);
            this.$edApi
                .getOpenRecord(obj)
                .then((list) => {
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    list.sort((a, b) => {
                        return new Date(b.opened_at).getTime() - new Date(a.opened_at).getTime();
                    });
                    let arr = [];
                    let nowArr = [],
                        preArr = [],
                        sevenArr = [],
                        nowMArr = [],
                        preMArr = [],
                        prePreMArr = [],
                        otherArr = [];
                    let addToArr = (obj) => {
                        let time = new Date(obj.opened_at);
                        let type = this.getRelativeTime(time);
                        switch (type) {
                            case "now":
                                nowArr.push(obj);
                                break;
                            case "preday":
                                preArr.push(obj);
                                break;
                            case "7day":
                                sevenArr.push(obj);
                                break;
                            case "nowMonth":
                                nowMArr.push(obj);
                                break;
                            case "preMonth":
                                preMArr.push(obj);
                                break;
                            case "prePreMonth":
                                prePreMArr.push(obj);
                                break;
                            case "other":
                                otherArr.push(obj);
                                break;
                        }
                    };
                    let index = 0;
                    for (let i = 0; i < list.length; i++) {
                        if (list[i].obj) {
                            let obj = {
                                index: index,
                                id: list[i].id,
                                objId: list[i].obj_id,
                                key: list[i].obj.obj,
                                size: list[i].obj.size,
                                opened_at: list[i].opened_at,
                                info: list[i].obj || null,
                                name: "",
                            };
                            if (this.isPrivate) {
                                obj.name = list[i].obj.name;
                                Object.assign(obj, {
                                    prefix: list[i].prefix,
                                });
                            } else {
                                let nameList = obj.key.split("/");
                                let name = nameList[nameList.length - 1];
                                name = name.match(/(.*)\.eddx/) && name.match(/(.*)\.eddx/)[1];
                                obj.name = name;
                            }
                            arr.push(obj);
                            addToArr(obj);
                            index++;
                        }
                    }
                    console.log(arr, nowArr, preArr, sevenArr, nowMArr, preMArr, prePreMArr);
                    this.filesList = arr;
                    this.nowList = nowArr;
                    this.preList = preArr;
                    this.sevenList = sevenArr;
                    this.nowMList = nowMArr;
                    this.preMList = preMArr;
                    this.prePreMList = prePreMArr;
                    this.otherList = otherArr;
                    this.loadingStatus = false;
                })
                .catch((err) => {
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    this.loadingStatus = false;
                });
        }

        loadErr(e) {
            let lang = this.lang == "zh" ? "zh" : "en";
            e.target.src = require(`@/home/assets/img/files/default-files-${lang}.svg`);
        }

        contextmenu(e, files, index) {}

        locateFile() {
            if (this.fileSelected.length > 1) return;
            let file = this.filesList[this.fileSelected[0]];
            if (this.searchValue) {
                file = this.searchList[this.fileSelected[0]];
            }
            console.log(file);
            this.$bus.$emit("jumpToTarget", file);
        }

        deleteRecord() {
            if (this.deleteRecordBlock) return;
            this.deleteRecordBlock = true;
            let selectArr = [];
            let list = this.activeList;
            for (let i = 0; i < this.fileSelected.length; i++) {
                selectArr.push(list[this.fileSelected[i]].id);
            }
            let params = Object.assign({ objId: selectArr }, this.$store.getters.apiParam);
            this.$edApi
                .deleteOpenRecord(params)
                .then((e) => {
                    this.getHistoryViewList();
                    this.clearFile();
                    this.deleteRecordBlock = false;
                })
                .catch((e) => {
                    this.deleteRecordBlock = false;
                });
        }

        getRelativeTime(timeStamp) {
            let getPreMonthZero = (m) => {
                let d = new Date();
                d.setDate(1);
                d.setMonth(m - 1);
                return new Date(new Date(d).toLocaleDateString()).getTime();
            };
            let nowTime = new Date(timeStamp);
            let month = nowTime.getMonth();
            let nowZero = new Date(new Date().toLocaleDateString()).getTime(); // 当天零点
            let preZero = nowZero - 24 * 60 * 60 * 1000; // 前一天零点
            let sevenZero = nowZero - 6 * 24 * 60 * 60 * 1000; // 7天零点
            let nowMonthZero = new Date(new Date().toLocaleDateString()).setDate(1); // 当月零点
            let preMonthZero = getPreMonthZero(month); // 上月零点
            let prePreMonthZero = getPreMonthZero(month - 1); // 上上月零点

            const currentTime = new Date().getTime();
            let diff = currentTime - timeStamp;
            if (diff < 0 || timeStamp > nowZero) {
                return "now";
            } else if (timeStamp > preZero) {
                return "preday";
            } else if (timeStamp > sevenZero) {
                return "7day";
            } else if (timeStamp > nowMonthZero) {
                return "nowMonth";
            } else if (timeStamp > preMonthZero) {
                return "preMonth";
            } else if (timeStamp > prePreMonthZero) {
                return "prePreMonth";
            } else {
                return "other";
            }
        }

        get selFiles() {
            let list = this.activeList;
            return list.filter((_, i) => {
                return this.selectFilesIndex.includes(i);
            });
        }

        setStarFile(file = null) {
            let done = () => {
                this.$bus.$emit("changeFileInfo", {
                    id: tempId,
                    key: "start_tag",
                    path,
                    value: type,
                });
                this.$bus.$emit("refreshStar");
                this.getHistoryViewList();
            };
            let tempId = -1;
            let type = 0;
            let path = "",
                pathArr = [];
            if (file) {
                type = file.info.start_tag ^ 1;
                tempId = file.info.id;
                pathArr = file.info.obj.split("/");
                pathArr.shift();
                pathArr.shift();
                pathArr.pop();
                this.$store.dispatch("setStarFile", { type: type, id: file.info.id, file_key: file.info.file_key }).then((res) => {
                    file.info.start_tag = type;
                    done();
                });
            } else {
                type = this.selFiles[0].info.start_tag ^ 1;
                tempId = this.selFiles[0].info.id;
                pathArr = this.selFiles[0].key.split("/");
                pathArr.shift();
                pathArr.shift();
                pathArr.pop();
                if (pathArr.length > 0) {
                    path = pathArr.join("/") + "/";
                }
                this.$store.dispatch("setStarFile", { type: type, id: this.selFiles[0].info.id, file_key: file.info.file_key }).then((res) => {
                    this.selFiles[0].info.start_tag = type;
                    done();
                });
            }
        }
        beforeDestroy() {
            this.clearFile();
            this.contextmenuBoxShow = false;
            this.$bus.$off("refreshHistoryView");
            this.$bus.$off("loginSucc-history");
            window.removeEventListener("message", this.receiveMessage);
            document.onvisibilitychange = null;
            document.removeEventListener("visibilitychange", this.visibilitychangeEvent);
        }
    }
</script>
<i18n>
{
  "zh": {
    "title": "历史浏览",
    "name": "文件名",
    "time": "打开时间",
    "size": "文件大小",
    "openFile": "打开",
    "locateFile": "定位到",
    "deleteRecord": "删除记录",
    "search": "搜索文件",
    "return": "返回",
    "notTem": "您最近没有浏览过自己的文件~",
    "notFind": "没有查到相应的浏览记录",
    "date-month": "月",
    "date-now": "今天",
    "date-preday": "昨天",
    "date-7day": "7天内",
    "date-nowMonth": "本月",
    "date-preMonth": "上月",
    "switchView": "切换视图",
    "personal": "个人云",
    "date-other": "三个月前"
  },
  "en": {
    "title": "Historical browsing",
    "name": "File name",
    "time": "Open time",
    "size": "File size",
    "openFile": "Open",
    "locateFile": "Targeting",
    "deleteRecord": "Delete",
    "search": "Search file",
    "return": "Return",
    "notTem": "You have not viewed your files recently.",
    "notFind": "Not Find",
    "date-month": "Month",
    "date-now": "Today",
    "date-preday": "Yesterday",
    "date-7day": "Within 7 days",
    "date-nowMonth": "This Month",
    "date-preMonth": "Last Month",
    "switchView": "Switch View",
    "personal": "Personal",
    "date-other": "Three months ago"
  },
  "fr": {
    "title": "Navigation historique",
    "name": "nom de fichier",
    "time": "Temps ouvert",
    "size": "Taille du fichier",
    "openFile": "ouvrir",
    "locateFile": "Ciblage",
    "deleteRecord": "supprimer",
    "search": "Rechercher un fichier",
    "return": "retour",
    "notTem": "Vous n'avez pas consulté vos fichiers récemment.",
    "notFind": "Aucun historique de navigation correspondant trouvé",
    "date-month": "Mois",
    "date-now": "Aujourd'hui",
    "date-preday": "Hier",
    "date-7day": "Dans les 7 jours",
    "date-nowMonth": "Ce mois-ci",
    "date-preMonth": "Le mois dernier",
    "switchView": "Changer de vue",
    "personal": "Cloud personnel",
    "date-other": "Il y a trois mois"
  },
  "de": {
    "title": "Historisches Browsen",
    "name": "Dateiname",
    "time": "Öffnungszeit",
    "size": "Dateigröße",
    "openFile": "Anschalten",
    "locateFile": "Lokalisieren",
    "deleteRecord": "Aufzeichnung löschen",
    "search": "Datei durchsuchen",
    "return": "Rückkehr",
    "notTem": "Sie haben Ihre Dateien in letzter Zeit nicht angezeigt.",
    "notFind": "Keinen entsprechenden Browsenverlauf gefunden",
    "date-month": "Monat",
    "date-now": "Heute",
    "date-preday": "Gestern",
    "date-7day": "Innerhalb von 7 Werktage",
    "date-nowMonth": "Diesen Monat",
    "date-preMonth": "Letzten Monat",
    "switchView": "Ansicht wechseln",
    "personal": "Persönlicher Cloud",
    "date-other": "Vor drei Monaten"
  },
  "jp": {
    "title": "閲覧履歴",
    "name": "ファイル名",
    "time": "時間",
    "size": "サイズ",
    "openFile": "開く",
    "locateFile": "保存場所",
    "deleteRecord": "削除",
    "search": "ファイルを検索",
    "return": "戻る",
    "notTem": "最近開いたファイルはありません",
    "notFind": "該当する閲覧履歴は見つかりませんでした",
    "date-month": "月",
    "date-now": "今日",
    "date-preday": "昨日",
    "date-7day": "7日以内",
    "date-nowMonth": "今月",
    "date-preMonth": "先月",
    "switchView": "ビューを切り替える",
    "personal": "個人クラウド",
    "date-other": "3ヶ月前"
  },
  "es": {
    "title": "Historial",
    "name": "nombre del archivo",
    "time": "Tiempo abierto",
    "size": "Tamaño del archivo",
    "openFile": "encender",
    "locateFile": "Orientación",
    "deleteRecord": "Eliminar el registro",
    "search": "Archivo de búsqueda",
    "return": "regreso",
    "notTem": "No ha visto sus archivos recientemente",
    "notFind": "No encontrar",
    "date-month": "Mes",
    "date-now": "Hoy",
    "date-preday": "Ayer",
    "date-7day": "Dentro de 7 dias",
    "date-nowMonth": "Este mes",
    "date-preMonth": "El mes pasado",
    "switchView": "Cambiar vista",
    "personal": "Nube Personal",
    "date-other": "Hace tres meses"
  },
  "pt": {
    "title": "Navegação histórica",
    "name": "nome do arquivo",
    "time": "Tempo aberto",
    "size": "Tamanho do arquivo",
    "openFile": "Ligar",
    "locateFile": "Alvejando",
    "deleteRecord": "Apagar registro",
    "search": "Pesquisar arquivo",
    "return": "Retorna",
    "notTem": "Você não olhou para seus arquivos recentemente",
    "notFind": "Não Encontrado",
    "date-month": "mês",
    "date-now": "hoje",
    "date-preday": "ontem",
    "date-7day": "Dentro de 7 dias",
    "date-nowMonth": "este mês",
    "date-preMonth": "mês anterior",
    "switchView": "Trocar Visualização",
    "personal": "Pessoal",
    "date-other": "Três meses atrás."
  },
  "it": {
    "title": "Navigazione storica",
    "name": "nome del file",
    "time": "Tempo aperto",
    "size": "Dimensione del file",
    "openFile": "accendere",
    "locateFile": "Targeting",
    "deleteRecord": "Elimina record",
    "search": "Cerca file",
    "return": "ritorno",
    "notTem": "Guarda quanto spazio vuoto che c'è! Che ne diresti di ravvivare un po' la situazione?",
    "notFind": "Nessuna cronologia di navigazione corrispondente trovata",
    "date-month": "Mese",
    "date-now": "Oggi",
    "date-preday": "Ieri",
    "date-7day": "Entro 7 giorni",
    "date-nowMonth": "Questo mese",
    "date-preMonth": "Il mese scorso",
    "switchView": "Cambia Vista",
    "personal": "Personali",
    "date-other": "Tre mesi fa"
  },
  "tw": {
    "title": "歷史瀏覽",
    "name": "檔案名",
    "time": "打開時間",
    "size": "檔案大小",
    "openFile": "打開",
    "locateFile": "定位到",
    "deleteRecord": "刪除記錄",
    "search": "搜尋檔案",
    "return": "返回",
    "notTem": "您最近沒有瀏覽過自己的檔案~",
    "notFind": "沒有查到相應的瀏覽記錄",
    "date-month": "月",
    "date-now": "今天",
    "date-preday": "昨天",
    "date-7day": "7天內",
    "date-nowMonth": "本月",
    "date-preMonth": "上月",
    "switchView": "切換視圖",
    "personal": "個人雲端硬碟",
    "date-other": "三個月前"
  },
  "kr": {
    "title": "조회 기록",
    "name": "이름",
    "time": "파일 열기 시간",
    "size": "파일 크기",
    "openFile": "파일 열기",
    "locateFile": "파일 위치",
    "deleteRecord": "기록 삭제",
    "search": "파일 찾기",
    "return": "돌아가기",
    "notTem": "아직 사용자님이 생성한 파일을 한 번도 조회하지 않았습니다!",
    "notFind": "해당 파일을 찾을 수 없습니다!",
    "date-month": "달",
    "date-now": "요즘",
    "date-preday": "어제",
    "date-7day": "7 일 이내",
    "date-nowMonth": "이번 달",
    "date-preMonth": "지난 달",
    "switchView": "보기 전환",
    "personal": "개인 클라우드",
    "date-other": "3 개월 전에"
  },
  "id": {
    "title": "Penelusuran historis",
    "name": "Nama file",
    "time": "Buka waktu",
    "size": "Ukuran file",
    "openFile": "Buka",
    "locateFile": "Penargetan",
    "deleteRecord": "Hapus",
    "search": "Cari file",
    "return": "Kembali",
    "notTem": "Anda belum melihat file Anda baru-baru ini.",
    "notFind": "Tidak Menemukan",
    "date-month": "Bulan",
    "date-now": "Hari Ini",
    "date-preday": "Kemarin",
    "date-7day": "7 hari ini",
    "date-nowMonth": "Bulan Ini",
    "date-preMonth": "Bulan Lalu",
    "switchView": "Ganti Tampilan",
    "personal": "Personal",
    "date-other": "Tiga bulan yang lalu"
  }
}
</i18n>
